import { render, staticRenderFns } from "./RelayIdTable.vue?vue&type=template&id=5f040f2d"
import script from "./RelayIdTable.vue?vue&type=script&lang=js"
export * from "./RelayIdTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports